<template>
    <div class="contact-card-list__item">
        <contact-item-v1 :item="item" v-if="!item.ContactsCallCenter"></contact-item-v1>

        <contact-item-v2 :item="item" v-else></contact-item-v2>
    </div>
</template>
<script>
    import contactItemV1 from './ContactCardItemV1.vue'
    import contactItemV2 from './ContactCardItemV2.vue'
    export default {
        props: {
            item: Object,
            selectedClientServiceTypeId: Number
        },
        components: {
            'contact-item-v1': contactItemV1,
            'contact-item-v2': contactItemV2,
        }
    }
</script>


// WEBPACK FOOTER //
// Scripts/app/FooterContactInfo/ContactCardItemSelector.vue